import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import homeRouter from './modules/home.js';
import noLayout from './modules/noLayout.js';
import specialTopicRouter from './modules/specialTopic.js';
import southern from './modules/southern.js';
import southernEn from './modules/southernEn.js';

export const constantRoutes = [
	homeRouter,
	specialTopicRouter,
	noLayout,
	southern,
	southernEn,
];
export const asyncRoutes = [homeRouter];
const createRouter = () =>
	new VueRouter({
		mode: 'history', // require service support
		scrollBehavior: () => ({ y: 0 }),
		routes: constantRoutes,
	});

const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter();
	router.matcher = newRouter.matcher; // reset router
}
// 防止重复重定向
let hasRedirected = false;
router.beforeEach(async (to, from, next) => {
	const hostname = window.location.hostname; // 获取当前域名
	// console.log(document);

	// 设置标题
	if (
		to.name === 'cn' ||
		to.name === 'detailsSouthern' ||
		to.name === 'reportListCn' ||
		to.name === 'activityListCn'
	) {
		document.title = '全球南方研究中心';
		setFavicon('/favicon-gsrc.ico');
	} else if (
		to.name === 'en' ||
		to.name === 'detailsSouthernEn' ||
		to.name === 'reportListEn' ||
		to.name === 'activityListEn'
	) {
		document.title = 'Global South Research Center';
		setFavicon('/favicon-gsrc.ico');
	} else {
		document.title = '中国国际发展知识中心';
		setFavicon('/favicon.ico');
	}
	// ✅ 只对根域名 www.gsrc-web.net 做语言判断
	if (
		hostname === 'www.gsrc-web.net' &&
		!hasRedirected &&
		to.path === '/' // 仅当访问根路径时才判断
	) {
		hasRedirected = true;
		let target = '/en';

		// 1️⃣ 优先使用浏览器语言
		const lang = (
			navigator.language ||
			navigator.userLanguage ||
			''
		).toLowerCase();
		if (lang.includes('zh')) {
			target = '/cn';
		} else {
			target = '/en';
		}

		// 2️⃣ （可选）尝试通过 IP 判断（仅当需要时）
		// try {
		// 	const res = await axios.get('https://ipapi.co/json/');
		// 	if (res.data && res.data.country_code === 'CN') {
		// 		target = '/cn';
		// 	}
		// } catch (e) {
		// 	console.warn('🌐 IP 判断失败，使用语言判断结果');
		// }

		next(target);
		return;
	}

	// 其他页面正常放行
	next();
});
function setFavicon(url) {
	let link =
		document.querySelector("link[rel*='icon']") ||
		document.createElement('link');
	link.type = 'image/x-icon';
	link.rel = 'shortcut icon';
	link.href = url;
	document.getElementsByTagName('head')[0].appendChild(link);
}

export default router;
